import React from 'react';
import ReddyLayout from '../components/home/ReddyLayout';
import GameThumbGrid from '../components/home/GameThumbGrid';
import SportSection from '../components/home/SportSection';
import CasinoProviderGrid from '../components/home/CasinoProviderGrid';
import UpcomingEvents from '../components/home/UpcomingEvents';
import { SPORT_SECTIONS } from '../data/homeData';

export default function HomePage() {
  return (
    <ReddyLayout>
      {/* .home-page = the reference homepage wrapper; activates its scoped mobile rules
          (.home-page .bet-button-price em{display:none} hides odds volume ≤991px,
          .home-page .bet-table-row .bl-box{height:28px} compacts the odds cells) */}
      <div className="home-page">
        {/* mobile-only game thumb-grid (self-hides on desktop → cricket table stays first) */}
        <GameThumbGrid />
        {SPORT_SECTIONS.map((s) => <SportSection key={s.key} section={s} />)}
        <CasinoProviderGrid />
        <UpcomingEvents />
      </div>
    </ReddyLayout>
  );
}
